import useTable from "../../../../MainComponents/Hooks/useTable.jsx";
import HelmetTags from "../../../../MainComponents/HelmetTags.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Col, Row } from "antd";
import { useEffect, useMemo, useState } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import Loader from "../../../../MainComponents/Loader.jsx";

function Students() {
  const [activeGroup, setActiveGroup] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [refetch, setReFetch] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, activeGroup]);

  const requestBody = useMemo(
    () => ({
      page,
      limit: pageSize,
      ...(debouncedSearch ? { search: debouncedSearch } : {}),
      ...(activeGroup ? { group: activeGroup } : {}),
    }),
    [page, pageSize, debouncedSearch, activeGroup]
  );

  const [DataAllStudents, ErrorAllStudents, LoadingAllStudents] = useAxios(
    process.env.REACT_APP_ADMIN_STUDENTS_TAB_API,
    "GET",
    "GET",
    refetch,
    requestBody,
    false,
    JSON.stringify(requestBody)
  );
  const [DataAllGroups] = useAxios(
    process.env.REACT_APP_ALL_GROUPS_API,
    "GET",
    "GET",
    ""
  );

  const studentsData = DataAllStudents?.data || [];
  const total = DataAllStudents?.meta?.total || 0;

  const table = useTable(
    "students",
    "",
    "",
    "",
    "",
    "",
    true,
    studentsData,
    refetch,
    setReFetch,
    "",
    {
      current: page,
      pageSize,
      total,
      onChange: (nextPage, nextPageSize) => {
        setPage(nextPage);
        setPageSize(nextPageSize);
      },
      onSearch: (value) => {
        setSearch(value);
      },
      onResetFilters: () => {
        setActiveGroup(null);
        setSearch("");
        setDebouncedSearch("");
        setPage(1);
      },
      exportParams: {
        ...(debouncedSearch ? { search: debouncedSearch } : {}),
        ...(activeGroup ? { group: activeGroup } : {}),
      },
    }
  );

  const handleGroupClick = (group) => {
    setActiveGroup(group);
    setPage(1);
  };

  const handleClearGroup = () => {
    setActiveGroup(null);
    setPage(1);
  };

  if (LoadingAllStudents && !DataAllStudents) {
    return <Loader />;
  }

  return (
    <section className="h-full w-full overflow-y-auto px-20 py-20 dark:bg-dark dark:text-light sm:px-10">
      <HelmetTags title={`Students | Mr Ibrahim Abdel Masseh`} />

      <div className="mb-32 flex flex-col items-end gap-10">
        <h2 className="w-full text-4xl font-bold md:text-center">Students</h2>

        <div className="flex flex-col w-full gap-10 md:justify-evenly items-start">
          <Row
            gutter={[16, 16]}
            justify="center"
            align="middle"
            style={{ marginTop: "20px" }}
          >
            {DataAllGroups?.data
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item) => (
                <Col key={item.name}>
                  <button
                    onClick={() => handleGroupClick(item.name)}
                    disabled={activeGroup === item.name}
                    className={`rounded-xl border-2 border-secondary bg-secondary px-4 py-3 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90 ${
                      activeGroup === item.name
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  >
                    {item.name}
                  </button>
                </Col>
              ))}
          </Row>
          {activeGroup && (
            <button
              onClick={handleClearGroup}
              className="rounded-xl border-2 border-accent bg-accent px-4 py-2 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-accent active:scale-90"
            >
              Clear group filter
            </button>
          )}
          <Link to="/admin/students/add-student">
            <button className="mr-4 rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary active:scale-90">
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              Add Student
            </button>
          </Link>
        </div>
      </div>

      <div className="h-fit w-full">{table}</div>
      {ErrorAllStudents && (
        <p className="mt-4 text-center text-red-500">
          {typeof ErrorAllStudents === "string"
            ? ErrorAllStudents
            : "Failed to load students"}
        </p>
      )}
    </section>
  );
}

export default Students;
